import { render, staticRenderFns } from "./Setup_FlightsClasses.vue?vue&type=template&id=5b1ad256&scoped=true&"
import script from "./Setup_FlightsClasses.vue?vue&type=script&lang=js&"
export * from "./Setup_FlightsClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ad256",
  null
  
)

export default component.exports